'use client';

import { cn } from '@/lib/utils';

export default function ButtonLinkItem({
  linkDestination,
  linkIcon,
  linkText,
  openInNewTab = false,
  variant = 'primary',
  isDownload = false,
  downloadName,
}: {
  linkDestination: string;
  linkIcon: React.ReactNode;
  linkText: string;
  openInNewTab?: boolean;
  variant?: 'primary' | 'secondary';
  isDownload?: boolean;
  downloadName?: string;
}) {
  // Use a plain <a> instead of next/link: these destinations are external URLs
  // or mailto: links. next/link would issue RSC prefetch requests for those,
  // which return 500 from non-page handlers.
  const downloadAttr = downloadName ?? (isDownload || undefined);

  if (variant === 'secondary') {
    return (
      <a
        className={cn(
          `rounded-2xl
          glass-dark
          transition-all
          duration-300
          flex
          items-center
          justify-center
          gap-3
          hover:scale-[1.05]
          active:scale-[0.95]
          hover:shadow-xl
          hover:shadow-white/5
          font-bold
          text-sm
          sm:text-base
          h-12
          sm:h-14
          px-6
          sm:px-8
          w-full
          sm:w-auto
          sm:min-w-[180px]
          hover:bg-white/10
          border border-white/10
          hover:border-primary/50`,
        )}
        href={linkDestination}
        target={openInNewTab ? '_blank' : undefined}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
        download={downloadAttr}
      >
        {linkIcon}
        {linkText}
      </a>
    );
  }

  return (
    <a
      className={cn(
        `rounded-2xl
        bg-foreground
        text-background
        transition-all
        duration-300
        flex
        items-center
        justify-center
        gap-3
        hover:scale-[1.05]
        active:scale-[0.95]
        hover:shadow-xl
        hover:shadow-white/5
        border border-transparent
        hover:border-primary/50
        font-bold
        text-sm
        sm:text-base
        h-12
        sm:h-14
        px-6
        sm:px-8
        w-full
        sm:w-auto
        sm:min-w-[180px]
        ring-offset-background
        focus-visible:outline-none
        focus-visible:ring-2
        focus-visible:ring-ring
        focus-visible:ring-offset-2`,
      )}
      href={linkDestination}
      target={openInNewTab ? '_blank' : undefined}
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
      download={downloadAttr}
    >
      {linkIcon}
      {linkText}
      <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
    </a>
  );
}
